import { Route, Routes } from "react-router-dom";
import ViewPage from "./pages/ViewPage";
import CreatedPage from "./pages/CreatedPage";
import ConfigPage from "./pages/ConfigPage";
import KnowledgePage from "./pages/KnowledgePage";
import InstructionsPage from "./pages/InstructionsPage";
import ToolsPage from "./pages/ToolsPage";
import DocumentContent from "./pages/KnowledgePage/pages/DocumentsView/DocumentsView";
import DrivesContent from "./pages/KnowledgePage/pages/DrivesView/DrivesView";


const PlaygroundPage = () => {
  return (
    <Routes>
      <Route path=":agentId/*" element={<ViewPage />}>
        <Route index element={<CreatedPage />} />
        <Route path="create" element={<CreatedPage />} />
        <Route path="configuration" element={<ConfigPage />} />
        <Route path="knowledge/*" element={<KnowledgePage />} />
        <Route path="instructions" element={<InstructionsPage />} />
        <Route path="tools" element={<ToolsPage />} />
      </Route>
    </Routes>
  );
};

export default PlaygroundPage;
